import { useMutation } from '@tanstack/react-query';

import { authApi, type ActivateAccountRequest } from '@/api/routes/public/auth.api';
import { translateFile } from '@/i18n';

export const useActivateAccount = () => {
  return useMutation({
    mutationFn: (data: ActivateAccountRequest) => authApi.activateAccount(data),
    meta: {
      showUserMessage: false,
      defaultUserMessage: translateFile('api.hooks.public.useActivateAccount', 'error'),
    },
  });
};
